import { NavLink } from 'react-router-dom';
import { Grid, Gear, ArrowLeft, ChatDots } from 'react-bootstrap-icons';
import FullLogo from '../../img/FullLogoLargeText.png';

const navLinkClass = ({ isActive }) =>
  `app-sidebar__link${isActive ? ' app-sidebar__link--active' : ''}`;

const AppSidebar = () => (
  <aside className="app-sidebar">
    <NavLink to="/app/dashboard" className="app-sidebar__brand">
      <img src={FullLogo} alt="Garden Sync" className="app-sidebar__logo" />
    </NavLink>

    <nav className="app-sidebar__nav">
      <NavLink to="/app/dashboard" className={navLinkClass} end>
        <Grid size={18} />
        <span>Dashboard</span>
      </NavLink>
      <NavLink to="/app/settings" className={navLinkClass}>
        <Gear size={18} />
        <span>Settings</span>
      </NavLink>
      <a
        href="https://community.gardensync.com/communities/groups/garden-sync-community/home"
        target="_blank"
        rel="noopener noreferrer"
        className="app-sidebar__link"
      >
        <ChatDots size={18} />
        <span>Forum</span>
      </a>
    </nav>

    <div className="app-sidebar__footer">
      <NavLink to="/" className="app-sidebar__link">
        <ArrowLeft size={18} />
        <span>Back to site</span>
      </NavLink>
    </div>
  </aside>
);

export default AppSidebar;